import { IComponent, ICustomEventData } from '@modules/src/interfaces/IComponents'
import { ContainersNames } from '../../containers/ContainersNames'
import { AssetType } from '@modules/src/enums/AssetType'
import { Orientation } from '@modules/src/enums/Orientation'
import { ComponentEvent } from '@modules/src/enums/ComponentEvent'
import GameSignals from '../../signals/GameSignals'
import { SpineAnimation } from '@base/spineAnimation/SpineAnimation'
import { ModulesFacade } from '@modules/src/ModulesFacade'

export const POPUPS_TRANSITION_COMPONENT: IComponent = {
    name: ContainersNames.POPUPS_TRANSITION_CONTAINER,
    type: AssetType.CONTAINER,
    zIndex: new Map<Orientation, number>([
        [Orientation.LANDSCAPE, 430],
        [Orientation.PORTRAIT, 430],
    ]),
    visible: false,
    events: [
        {
            event: ComponentEvent.SHOW,
            onGameSignalsTriggered: [
                GameSignals.bonusStart,
                GameSignals.bonusStop,
                GameSignals.splashScreenButtonClicked,
            ],
        },
        {
            event: ComponentEvent.HIDE,
            onGameSignalsTriggered: [GameSignals.completeTransitionAnimation],
        },
    ],
    position: [
        {
            orientation: Orientation.LANDSCAPE,
            x: 0,
            y: 84,
        },
        {
            orientation: Orientation.PORTRAIT,
            x: 0,
            y: 84,
        },
    ],
    items: [
        {
            name: 'Intro Wave',
            type: AssetType.SPINE,
            visible: false,
            src: 'transition',
            animationSettings: {
                default: {
                    triggerGameSignals: [],
                    animNames: ['L'],
                    loops: [false],
                    track: 0,
                    timeScales: [1],
                },
            },
            events: [
                {
                    event: ComponentEvent.CUSTOM_NEW,
                    onGameSignalsTriggered: [GameSignals.bonusStart, GameSignals.bonusStop],
                    callback: function (data: ICustomEventData) {
                        const animation: SpineAnimation = data.component.componentElement
                        animation.visible = true
                        const isLandscape = ModulesFacade.orientation === Orientation.LANDSCAPE
                        const transitionAnimationName = isLandscape ? 'L' : 'P'

                        try {
                            animation.start([transitionAnimationName], [false], 0, [1], () => {
                                GameSignals.completeTransitionAnimation.emit()
                            })

                            const track = (animation as any)?.animation?.state?.tracks?.[0]
                            if (track) {
                                track.reverse = false
                            }
                        } catch (error) {
                            console.warn('[PopupsTransition] Failed to play transition animation:', error)
                            GameSignals.completeTransitionAnimation.emit()
                        }
                    },
                },
                {
                    event: ComponentEvent.CUSTOM_NEW,
                    onGameSignalsTriggered: [GameSignals.splashScreenButtonClicked],
                    callback: function (data: ICustomEventData) {
                        const animation: SpineAnimation = data.component.componentElement
                        const parentContainer: any = data.component.parentContainer
                        animation.visible = true
                        const isLandscape = ModulesFacade.orientation === Orientation.LANDSCAPE
                        const transitionAnimationName = isLandscape ? 'L' : 'P'

                        try {
                            // Splash: play transition forward (not loop)
                            animation.start([transitionAnimationName], [false], 0, [1], () => {
                                try {
                                    animation.stop()
                                } catch (e) {}

                                animation.visible = false
                                if (parentContainer) {
                                    parentContainer.visible = false
                                }

                                // Emit after the transition container is hidden
                                GameSignals.completeTransitionAnimation.emit()

                                // Open tournament only after splash transition has fully ended
                                requestAnimationFrame(() => {
                                    ;(GameSignals as any).openTournament?.emit()
                                })
                            })
                        } catch (error) {
                            console.warn('[PopupsTransition] Failed to play splash transition:', error)
                            animation.visible = false
                            if (parentContainer) {
                                parentContainer.visible = false
                            }
                            GameSignals.completeTransitionAnimation.emit()

                            requestAnimationFrame(() => {
                                ;(GameSignals as any).openTournament?.emit()
                            })
                        }
                    },
                },
            ],
            scale: [
                {
                    orientation: Orientation.LANDSCAPE,
                    x: 1.5,
                    y: 1.5,
                },
                {
                    orientation: Orientation.PORTRAIT,
                    x: 1.5,
                    y: 1.5,
                },
            ],
            position: [
                {
                    orientation: Orientation.LANDSCAPE,
                    x: 960,
                    y: 456.5,
                },
                {
                    orientation: Orientation.PORTRAIT,
                    x: 540,
                    y: 960,
                },
            ],
        },
    ],
}
